import clsx from "clsx";
import React from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";

import DealerPassportForm2 from "~/components/Forms/DealerPassportForm2";
import Preloader from "~/components/Preloader";
import { onScrollBottomDealers } from "~/hooks/selectDealerValue";
import { getNameSelection } from "~/libs/getData";
import { useGetDealerQuery } from "~/schemas/generated/graphql";

import s from "./DealerPassport.less";

const DealerPassport = () => {
  const { t } = useTranslation();
  const { params } = useRouteMatch();
  const DealerId = params["id"];
  const idArchive = params["period"];

  const isAdd = DealerId === "add";

  let dataNew;
  let refetchNew;
  let loadingNew;

  if (!isAdd) {
    const { data, refetch, loading } = useGetDealerQuery({
      variables: {
        DealerId,
        ArchivePeriodId: idArchive,
      },
      fetchPolicy: "no-cache",
    });
    dataNew = data;
    refetchNew = refetch;
    loadingNew = loading;
  }

  const getOneDealer = !!dataNew
    ? get(dataNew, "DealerGetter.getDealer", {})
    : {};

  const idPhoto = (name) => get(getOneDealer[name], "id", "");

  const oneDealer = getOneDealer && {
    ...getOneDealer,
    DealerName: getNameSelection("DealerName", getOneDealer),
    type: getNameSelection("type", getOneDealer),
    tradeDealerName: getNameSelection("tradeDealerName", getOneDealer),
    legalDealerName: getNameSelection("legalDealerName", getOneDealer),
    headName: getNameSelection("headName", getOneDealer),
    ownerName: getNameSelection("ownerName", getOneDealer),
    EP: getNameSelection("EP", getOneDealer),
    address: getNameSelection("address", getOneDealer),
    country: getNameSelection("country", getOneDealer),
    FO: getNameSelection("FO", getOneDealer),
    subject: getNameSelection("subject", getOneDealer),
    city: getNameSelection("city", getOneDealer),
    PhotoOwnerId: idPhoto("PhotoOwner"),
    PhotoDealerCenterId: idPhoto("PhotoDealerCenter"),
    PhotoBossId: idPhoto("PhotoBoss"),
    ScanBossPersonDataId: idPhoto("ScanBossPersonData"),
    ScanOwnerPersonDataId: idPhoto("ScanOwnerPersonData"),
    ScanLadaPersonDataId: idPhoto("ScanLadaPersonData"),
    ScanAccountantPersonDataId: idPhoto("ScanAccountantPersonData"),
  };

  const dealersForSelect = onScrollBottomDealers();

  if (loadingNew) {
    return <Preloader />;
  }

  return (
    <>
      {getOneDealer ? (
        <div
          className={clsx({
            [s.wrapper]: true,
          })}
        >
          <DealerPassportForm2
            isAdd={isAdd}
            DealerId={DealerId}
            idArchive={idArchive}
            oneDealer={oneDealer}
            dealersForSelect={dealersForSelect}
            refetch={refetchNew}
            DealerName={oneDealer.DealerName}
          />
        </div>
      ) : (
        <div className={s.error_not_dealer}>
          {" "}
          {t(`dealers.error_not_dealer`)}
        </div>
      )}

      <div className={"offset-footer"} />
    </>
  );
};

export default DealerPassport;
